import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PORTFOLIO } from "@/data";
import Reveal from "@/components/landing/Reveal";

const FILTERS = ["All", "Residential", "Commercial"];

export const Portfolio = () => {
  const [filter, setFilter] = useState("All");
  const items =
    filter === "All" ? PORTFOLIO : PORTFOLIO.filter((p) => p.category === filter);

  return (
    <section id="portfolio" data-testid="portfolio-section" className="bg-white py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <Reveal>
            <span className="font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">
              04 — Selected Work
            </span>
            <h2 className="mt-4 font-display font-bold uppercase text-navy text-4xl md:text-6xl leading-[0.9] tracking-tight">
              Recent transformations
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex gap-2" data-testid="portfolio-filters">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  onClick={() => setFilter(f)}
                  data-testid={`filter-${f.toLowerCase()}`}
                  className={`rounded-full px-5 py-2.5 font-body text-sm font-semibold transition-colors duration-200 ${
                    filter === f
                      ? "bg-navy text-white"
                      : "bg-cloud text-navy/70 hover:text-navy"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <AnimatePresence mode="popLayout">
            {items.map((p, i) => (
              <motion.div
                layout
                key={p.caption}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.4, delay: (i % 3) * 0.05 }}
                className={`group relative overflow-hidden rounded-2xl cursor-pointer ${
                  i === 0 ? "sm:col-span-2 sm:row-span-1" : ""
                }`}
                data-testid={`portfolio-item-${i}`}
              >
                <div className="overflow-hidden aspect-[4/3]">
                  <img
                    src={p.url}
                    alt={p.alt}
                    loading="lazy"
                    width="1200"
                    height="900"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/85 via-navy-dark/10 to-transparent opacity-90" />
                <div className="absolute top-4 left-4">
                  <span className="rounded-full bg-gold text-navy-dark text-xs font-bold uppercase tracking-wide px-3 py-1.5">
                    {p.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="font-body text-white/60 text-xs uppercase tracking-[0.2em]">
                    {p.category}
                  </span>
                  <h3 className="mt-1 font-display font-semibold text-white text-2xl">
                    {p.caption}
                  </h3>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
